
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  name: 'indexCategory',
  props: {
    pageStr: {
      type: String,
      required: true,
    },
  },
  setup() {
    return {}
  },
})
